import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useAxiosInstance } from "../../../../services/Interceptor";
import { useActVideo } from "../../../../hooks/useActVideo";
import { useState } from "react";
import {
  deleteVideoById,
  uploadAthleteTestVideo,
} from "../../../../services/FileUploadService";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowUp, faTrash } from "@fortawesome/free-solid-svg-icons";
import VideoPlayer from "../../../../components/VideoPlayer";
import ConfirmModal from "../../../../components/ConfirmModel";

export const VideoManagement = ({
  itemTest,
  saveDataRef,
  setBtnLoading,
  callGetCombine,
}) => {
  const { user } = useAuthUser() || {};
  const apiInstance = useAxiosInstance();
  const posToast = { position: "top-right" };
  const actVideo = useActVideo(itemTest);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [videoIdToDelete, setVideoIdToDelete] = useState(null);

  const sendVideo = async (event) => {
    setIsLoading(true);
    const fileToUpload = document.getElementById(event.target.id);
    const getFieldId = event.target.id.split("-");
    const fieldToRead = `athleteTestDetailId-${getFieldId[1]}`;
    let testAthleteDetailId = "";
    testAthleteDetailId = document.getElementById(fieldToRead).value;
    try {
      if (testAthleteDetailId === "") {
        await saveDataRef.current.click();
        setBtnLoading(true);
        testAthleteDetailId = document.getElementById(fieldToRead).value;
        await UploadVideo(testAthleteDetailId, fileToUpload, getFieldId[1]);
      } else {
        setBtnLoading(true);
        await UploadVideo(testAthleteDetailId, fileToUpload, getFieldId[1]);
      }
    } finally {
      setIsLoading(false);
    }
  };
  const UploadVideo = async (testAthleteDetailId, fileToUpload) => {
    setBtnLoading(true);
    setIsLoading(true);

    if (!fileToUpload.files || !fileToUpload.files[0]) {
      toast.warning("Please select a video file to upload.", posToast);
      setBtnLoading(false);
      setIsLoading(false);
      return;
    }

    const file = fileToUpload.files[0];

    if (!file.type.startsWith("video/")) {
      toast.warning("Only video files are allowed.", posToast);
      setBtnLoading(false);
      setIsLoading(false);
      return;
    }

    const maxFileSize = 600 * 1024 * 1024;
    if (file.size > maxFileSize) {
      toast.warning("Video size should not exceed 600MB.", posToast);
      setBtnLoading(false);
      setIsLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await uploadAthleteTestVideo(
        apiInstance,
        testAthleteDetailId,
        user.id,
        formData,
        setUploadProgress,
      );

      if (response.status === 200) {
        toast.success("Video uploaded successfully!", posToast);
        const fileUrl = response.data.fileUploadResponse.fileUrl;
        const fieldId = itemTest.fieldId;
        const videoId = response.data.fileUploadResponse.id;

        const videoContainer = document.getElementById(
          `video-player-${fieldId}`,
        );
        const toggle = document.getElementById(`videoToggle-${fieldId}`);
        const showVideo = document.getElementById(`show-video-${fieldId}`);
        const videoIdInput = document.getElementById(`videoId-${fieldId}`);

        if (videoContainer && toggle && showVideo && videoIdInput) {
          const hasVideo = fileUrl !== "";
          showVideo.classList.toggle("hidden", !hasVideo);
          showVideo.classList.toggle("flex", hasVideo);
          videoContainer.src = hasVideo ? fileUrl : "";
          videoIdInput.value = hasVideo ? videoId : "";
          toggle.classList.toggle("hidden", hasVideo);
        }
        callGetCombine(false);
      } else {
        toast.error("Unexpected response from server. Try again.", posToast);
      }
    } catch (err) {
      console.error(err);
      toast.error(
        "There was a problem uploading your video. Try again.",
        posToast,
      );
    } finally {
      setIsLoading(false);
      setBtnLoading(false);
      setUploadProgress(0);
    }
  };

  const deleteVideo = (fieldId) => {
    setVideoIdToDelete(fieldId);
    setShowConfirmModal(true);
  };

  const handleConfirmDelete = async () => {
    if (videoIdToDelete) {
      setIsLoading(true);
      try {
        document.querySelectorAll("[id^='deleteVideo-']").forEach((element) => {
          element.classList.add("hidden");
        });
        const videoIdLabel = document.getElementById(
          `videoId-${videoIdToDelete}`,
        );
        let videoId = videoIdLabel.value;
        let response = await deleteVideoById(apiInstance, videoId);
        if (response) {
          toast.success("Video deleted successfully!", posToast);
          const fieldId = videoIdToDelete;
          const videoContainer = document.getElementById(
            `video-player-${fieldId}`,
          );
          const toggle = document.getElementById(`videoToggle-${fieldId}`);
          const showVideo = document.getElementById(`show-video-${fieldId}`);
          const videoIdInput = document.getElementById(`videoId-${fieldId}`);
          if (videoContainer) videoContainer.src = "";
          if (showVideo) {
            showVideo.classList.add("hidden");
            showVideo.classList.remove("flex");
          }
          if (toggle) toggle.classList.remove("hidden");
          if (videoIdInput) videoIdInput.value = "";
          callGetCombine(true);
        }
      } catch (err) {
        toast.error(
          "There was a problem deleting your video. Try Again",
          posToast,
        );
      } finally {
        document.querySelectorAll("[id^='deleteVideo-']").forEach((element) => {
          element.classList.remove("hidden");
        });
        setIsLoading(false);
        setVideoIdToDelete(null);
        setShowConfirmModal(false);
      }
    }
  };

  const handleCancelDelete = () => {
    setShowConfirmModal(false);
    setVideoIdToDelete(null);
  };
  return (
    <>
      <div className="flex flex-col items-end">
        <div className="flex items-center justify-end pr-2 my-2">
          {isLoading ? (
            <div className="flex mr-6"></div>
          ) : (
            actVideo && (
              <>
                <div
                  id={`show-video-${itemTest.fieldId}`}
                  className="bg-transparent items-center hidden"
                >
                  <VideoPlayer
                    id={`video-player-${itemTest.fieldId}`}
                    src=""
                    className="max-md:!w-[120px] max-md:!h-[80px]"
                  />
                  <Link
                    className="mx-3"
                    id={`deleteVideo-${itemTest.fieldId}`}
                    onClick={() => deleteVideo(itemTest.fieldId)}
                  >
                    <FontAwesomeIcon
                      icon={faTrash}
                      size="sm"
                      className="text-gray-500"
                    />
                  </Link>
                  <input
                    type="hidden"
                    id={`videoId-${itemTest.fieldId}`}
                    readOnly
                  />
                </div>
                <div
                  id={`videoToggle-${itemTest.fieldId}`}
                  className={`border border-blue-700 border-dashed rounded-lg cursor-pointer px-1 py-1 xl:px-4 xl:py-2`}
                >
                  <label htmlFor={`video-${itemTest.fieldId}`}>
                    <div className="flex flex-col items-center cursor-pointer">
                      <FontAwesomeIcon
                        icon={faCircleArrowUp}
                        size="lg"
                        className="text-gray-500"
                      />
                      <p className="mb-2 text-xs text-gray-500 dark:text-gray-400">
                        <span className="font-normal">
                          Click to upload Video
                        </span>
                      </p>
                    </div>
                    <input
                      id={`video-${itemTest.fieldId}`}
                      type="file"
                      accept="video/*"
                      className="hidden"
                      onChange={sendVideo}
                    />
                  </label>
                </div>

                <ConfirmModal
                  show={showConfirmModal}
                  message="Are you sure you want to delete this video?"
                  onConfirm={handleConfirmDelete}
                  onCancel={handleCancelDelete}
                />
              </>
            )
          )}
        </div>

        {uploadProgress > 0 && uploadProgress < 100 && (
          <div className="w-full pr-2 mb-2">
            <div className="bg-gray-300 rounded-full h-2 w-full">
              <div
                className="bg-green-600 h-2 rounded-full transition-all duration-300 ease-in-out"
                style={{ width: `${uploadProgress}%` }}
              ></div>
            </div>
            <p className="text-xs text-gray-600 mt-1 text-right pr-1">
              Uploading: {uploadProgress}%
            </p>
          </div>
        )}

        <input
          type="hidden"
          id={`athleteTestDetailId-${itemTest.fieldId}`}
          readOnly
        />
      </div>
    </>
  );
};
